/**
 * Mientras una unidad se sustituye, la nueva ocupa el mismo volumen que la
 * anterior. El guard de geometría no debe borrarla por esa colisión: la
 * unidad vieja se elimina al confirmar el dibujo.
 */
const exemptUnitIds = new Map<string, number>()

export function exemptUnitFromCollisionChecks(id: string): () => void {
  const key = String(id)
  exemptUnitIds.set(key, (exemptUnitIds.get(key) ?? 0) + 1)
  let released = false
  return () => {
    if (released) return
    released = true
    const next = (exemptUnitIds.get(key) ?? 0) - 1
    if (next <= 0) exemptUnitIds.delete(key)
    else exemptUnitIds.set(key, next)
  }
}

export function isCollisionCheckExempt(id: string): boolean {
  return (exemptUnitIds.get(String(id)) ?? 0) > 0
}
